import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  ToastContainer,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  CalendarIcon,
  CheckIcon,
  KeyIcon,
  MailIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  useCheckUserDetailsMutation,
  useCountriesOptionsMutation,
  useUploadMediaMutation,
  useVendorRegistrationMutation,
} from "Services/services";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";
import { Routes } from "routes";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { MdOutlineAutoMode } from "react-icons/md";
import Select from "react-select";
import { FaCircleInfo } from "react-icons/fa6";

export default () => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("");

  const [vendorRegistration] = useVendorRegistrationMutation();
  const [getCountries] = useCountriesOptionsMutation();
  const [getmediaUrl] = useUploadMediaMutation();
  const [verify] = useCheckUserDetailsMutation();

  const [validated, setValidated] = useState(false);

  // Get the usertype from localStorage
  const [formData, setFormData] = useState({
    vendor: "",
    username: "",
    contactName: "",
    websiteUrl: "",
    retentionPolicy: "",
    complianceCertificate: "",
    gst: "",
  });
  const [ipParts, setIpParts] = useState(["", "", "", ""]);
  const [validity, setValidity] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isVerifiedPhone, setisVerifiedPhone] = useState();
  const [isVerifiedEmail, setisVerifiedEmail] = useState();
  const [password, setPassword] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [error, setError] = useState({});

  useEffect(() => {
    fetchCountries();
    // eslint-disable-next-line
  }, []);

  const history = useHistory();

  const handleIPChange = (index, value) => {
    if (value === "" || (/^\d{1,3}$/.test(value) && +value <= 255)) {
      const newParts = [...ipParts];
      newParts[index] = value;
      setIpParts(newParts);

      // Only clear the error if form has been validated and all IP parts are valid
      if (validated) {
        const updatedParts = [...newParts];
        const isIPValid =
          updatedParts.length === 4 &&
          updatedParts.every((part) => {
            const num = Number(part);
            return /^\d{1,3}$/.test(part) && num >= 0 && num <= 255;
          });

        setError((prev) => ({
          ...prev,
          allowIp: !isIPValid,
        }));
      }
    }
  };

  const verifyPhone = (phone) => {
    setPhone(phone);
    const regex =
      /^(\+|00)?\d{1,3}[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    if (phone.length >= 6 && phone.length <= 13 && regex.test(phone)) {
      const postData = { data: phone };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedPhone(true);
            setError((prev) => ({ ...prev, phone: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedPhone(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedPhone(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedPhone(false);
    }
  };

  const verifyEmail = (e) => {
    const email = e.target.value;
    setEmail(email);

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regex.test(email)) {
      const postData = { data: email };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedEmail(true);
            setError((prev) => ({ ...prev, email: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedEmail(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedEmail(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedEmail(false);
    }
  };
  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";

    const all = lower + upper + numbers + symbols;

    let password = "";
    password += lower[Math.floor(Math.random() * lower.length)];
    password += upper[Math.floor(Math.random() * upper.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    for (let i = 4; i < length; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    // Shuffle password to remove predictable pattern
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    setPassword(password);

    setError((prev) => ({
      ...prev,
      password: false,
    }));
  };

  const fetchCountries = async () => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.dialCode})`,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const formData = new FormData();
    formData.append("file", files[0]);
    let fileUrl = null;
    getmediaUrl(formData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          fileUrl = success?.data?.data?.url;
          console.log("fileUrl", fileUrl);
          setFormData((prevData) => ({
            ...prevData,
            [name]: fileUrl, // store only the first file
          }));
        } else if (success?.data?.statusCode > 300) {
          alert(success?.data?.message || "something went wrong!");
        } else {
          alert(success?.error?.error || "something went wrong!");
          alert(`${files[0].name} could not be uploaded!`);
        }
      })
      .catch((error) => {
        alert(error?.message);
      });

    // console.log("file changed", name, files, formData);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.vendor.trim()) newErrors.vendor = true;
    if (!formData.username.trim()) newErrors.username = true;
    if (!password.trim()) newErrors.password = true;
    if (!selectedCountry) newErrors.country = true;
    if (!formData.contactName.trim()) newErrors.contactName = true;
    if (!email.trim()) newErrors.email = true;
    if (!phone.trim()) newErrors.phone = true;
    if (!formData.websiteUrl.trim()) newErrors.websiteUrl = true;
    if (ipParts.join(".") === "...") newErrors.allowIp = true;
    if (!validity) newErrors.accountValidity = true;

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isFormValid = validateForm();

    if (!isFormValid) {
      setValidated(true);
      return;
    }

    const formPayload = {
      vendor_name: formData.vendor,
      status: "active", // active deactive
      username: formData.username,
      password: password,
      vendor_country: selectedCountry?.value,
      person_name: formData.contactName,
      email: email,
      phone: phone,
      website_url: formData.websiteUrl,
      allow_ip: ipParts.join("."),
      account_validity: moment(validity).format("YYYY-MM-DD"),
      data_retenton_policy: formData.retentionPolicy,
      security_compliance_certification: formData.complianceCertificate,
      gst: formData.gst,
      legal_aggreement_signed: true,
    };

    vendorRegistration(formPayload)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          setFormData({});
          setSelectedCountry(null);
          setPassword(null);
          setEmail("");
          setPhone("");
          setIpParts("");

          setTimeout(() => {
            history.push(Routes.VendorManagement.path);
          }, 1000);
        } else if (success?.data?.statusCode > 300) {
          setToastMessage(success?.data?.message || "An error occurred!");
          setToastVariant("danger");
        }
        setShowToast(true);
      })
      .catch((error) => {
        setToastMessage("Vendor onbording fail");
        setToastVariant("danger");
        setShowToast(true);
      });
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">Add Vendor</h5>
          <Form
            noValidate
            autoComplete="off"
            onSubmit={submitForm}
            validated={validated}
          >
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="vendor">
                  <RequiredLabel label="Vendor Name" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Vendor Name"
                    value={formData.vendor}
                    title="Vendor Name must be alphabetic entry"
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        vendor: val,
                      }));
                      if (/^[A-Za-z]{0,50}$/.test(val)) {
                        setError((prev) => ({ ...prev, vendor: false }));
                      } else {
                        setError((prev) => ({ ...prev, vendor: true }));
                      }
                    }}
                    pattern="^[a-zA-Z]+$"
                  />
                  {error.vendor && (
                    <div className="invalid-feedback d-block">
                      Enter a valid vendor name.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="username">
                  <RequiredLabel label="Username" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Username"
                    title="Enter a valid username with 3–30 alphanumeric characters only"
                    value={formData.username}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        username: val,
                      }));
                      if (/^[A-Za-z0-9]{0,30}$/.test(val)) {
                        setError((prev) => ({ ...prev, username: false }));
                      } else {
                        setError((prev) => ({ ...prev, username: true }));
                      }
                    }}
                    pattern="^[a-zA-Z0-9]+$"
                  />
                  {error.username && (
                    <div className="invalid-feedback d-block">
                      Enter a valid Username.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="password">
                  <Form.Label className="d-flex align-items-center gap-1">
                    <span>Password</span>
                    <span className="text-danger"> * </span>
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="ip-tooltip">
                          Password must be 8-32 characters, include uppercase,
                          lowercase, number, and special character.
                        </Tooltip>
                      }
                    >
                      <span
                        className="ms-1 text-primary"
                        style={{ cursor: "pointer" }}
                      >
                        <FaCircleInfo size={18} />
                      </span>
                    </OverlayTrigger>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <KeyIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Password"
                      title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                      value={password}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // Limit length and allow valid characters
                        if (newValue.length <= 32) {
                          setPassword(newValue);

                          // Validate live feedback
                          const isValid =
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(
                              newValue
                            );
                          setError((prev) => ({
                            ...prev,
                            password: !isValid,
                          }));
                        }
                      }}
                      maxLength={32}
                      autoComplete="new-password"
                    />
                    <InputGroup.Text>
                      <MdOutlineAutoMode
                        size={20}
                        onClick={generatePassword}
                        style={{ cursor: "pointer" }}
                        title="Auto-generate password"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                  {error.password && (
                    <div className="invalid-feedback d-block">
                      Enter a valid strong password.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="country">
                  <RequiredLabel label="Vendor Country" />
                  <Select
                    options={countryOptions}
                    placeholder="Select Country"
                    isSearchable={true}
                    value={selectedCountry}
                    onChange={(option) => {
                      setSelectedCountry(option);
                      setError((prev) => ({
                        ...prev,
                        country: false,
                      }));
                    }}
                    autoComplete="new-country"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor:
                          validated && error.country
                            ? "#dc3545"
                            : validated && selectedCountry
                            ? "#65BB82"
                            : "#ced4da",
                        borderRadius: "0.75rem",
                      }),
                    }}
                  />
                  {error.country && (
                    <div className="invalid-feedback d-block">
                      Please select a country.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="contactname">
                  <RequiredLabel label="Contact Person Name" />
                  <Form.Control
                    required
                    type="text"
                    placeholder="Contact Person Name"
                    value={formData.contactName}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        contactName: e.target.value,
                      }));
                      if (/^[A-Za-z]{0,50}$/.test(e.target.value)) {
                        setError((prev) => ({ ...prev, contactName: false }));
                      } else {
                        setError((prev) => ({ ...prev, contactName: true }));
                      }
                    }}
                    maxLength={50}
                    name="contactName"
                    title="Enter a valid name with 3–50 alphabetic characters only"
                  />
                  {error.contactName && (
                    <div className="invalid-feedback d-block">
                      Please provide Contact Name.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="email">
                  <RequiredLabel label="Email" />
                  <InputGroup>
                    <InputGroup.Text>
                      <MailIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="email"
                      placeholder="name@company.com"
                      value={email}
                      onChange={verifyEmail}
                      title="Enter a valid email address"
                      autoComplete="new-email"
                    />
                    {isVerifiedEmail && (
                      <InputGroup.Text title="Email is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedEmail === false && (
                      <InputGroup.Text title="Email is not available or unique">
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                  </InputGroup>
                  {error.email && (
                    <div className="invalid-feedback d-block">
                      Please provide valid email.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="phone">
                  <RequiredLabel label="Contact Phone" />
                  <InputGroup className="phone-input-group">
                    <PhoneInput
                      country={"in"}
                      value={phone}
                      onChange={verifyPhone}
                      placeholder="+91 99999-99999"
                      className={`phone-input ${
                        error.phone && !phone && !isVerifiedPhone
                          ? "is-invalid"
                          : isVerifiedPhone && phone
                          ? "is-valid"
                          : ""
                      }`}
                      autoComplete="new-phone"
                      title="Please enter a valid phone number in the format '+91 XXXXX-XXXXX'."
                    />
                    {isVerifiedPhone && (
                      <InputGroup.Text
                        className="phone-input-icon"
                        title="Phone number is available and unique"
                      >
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedPhone === false && (
                      <InputGroup.Text
                        className="phone-input-icon"
                        title="Phone number is not available or unique"
                      >
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                  </InputGroup>
                  {error.phone && !isVerifiedPhone && (
                    <div className="invalid-feedback d-block">
                      Enter a valid phone number.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="websiteUrl">
                  <RequiredLabel label="Website URL" />
                  <Form.Control
                    required
                    type="url"
                    placeholder="Website URL"
                    value={formData.websiteUrl}
                    onChange={(e) => {
                      const newValue = e.target.value;

                      if (newValue.length <= 32) {
                        setFormData((prev) => ({
                          ...prev,
                          websiteUrl: newValue,
                        }));

                        const isValid =
                          /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/\S*)?$/.test(
                            newValue.trim()
                          );

                        setError((prev) => ({
                          ...prev,
                          websiteUrl: !isValid && newValue !== "",
                        }));
                      }
                    }}
                    isValid={
                      validated &&
                      !error.websiteUrl &&
                      formData.websiteUrl !== ""
                    }
                    isInvalid={validated && error.websiteUrl}
                    title="Enter a valid URL like https://example.com"
                    autoComplete="new-url"
                  />

                  {error.websiteUrl && (
                    <div className="invalid-feedback d-block">
                      Please enter a valid website Url.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="api">
                  <RequiredLabel label="Allow IP" />
                  <div className="d-flex gap-2">
                    {[0, 1, 2, 3].map((index) => (
                      <Form.Control
                        key={index}
                        type="text"
                        value={ipParts[index] || ""}
                        onChange={(e) => handleIPChange(index, e.target.value)}
                        style={{
                          width: "60px",
                          textAlign: "center",
                          borderColor:
                            validated && error.allowIp
                              ? "#dc3545"
                              : validated && !error.allowIp
                              ? "#65BB82"
                              : "#ced4da",
                        }}
                        maxLength="3"
                        minLength={1}
                        autoComplete={`ip-segment-${index}`}
                      />
                    ))}
                  </div>
                  {error.allowIp && (
                    <div className="invalid-feedback d-block">
                      Please enter a valid IP.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="accountvalidity">
                  <RequiredLabel label="Account Validity" />
                  <Datetime
                    timeFormat={false}
                    onChange={(date) => {
                      setValidity(date);
                      setError((prev) => ({ ...prev, accountValidity: false }));
                    }}
                    isValidDate={(currentDate) =>
                      currentDate.isAfter(moment(), "day")
                    }
                    renderInput={(props, openCalendar) => (
                      <InputGroup>
                        <InputGroup.Text>
                          <CalendarIcon className="icon icon-xs" />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="text"
                          value={
                            validity
                              ? moment(validity).format("DD/MM/YYYY")
                              : ""
                          }
                          placeholder="DD/MM/YYYY"
                          onFocus={openCalendar}
                          onChange={() => {}}
                        />
                      </InputGroup>
                    )}
                  />
                  {error.accountValidity && (
                    <div className="invalid-feedback d-block">
                      Please enter a valid date.
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <h5 className="my-4">Policies</h5>

            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="retentionPolicy">
                  <Form.Label>Data Retention Policy</Form.Label>
                  <Form.Control
                    type="file"
                    name="retentionPolicy"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="complianceCertificate">
                  <Form.Label>Security Compliance Certificate</Form.Label>
                  <Form.Control
                    type="file"
                    name="complianceCertificate"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="gst">
                  <Form.Label>GST</Form.Label>
                  <Form.Control
                    type="file"
                    name="gst"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex">
              <Button
                type="submit"
                variant="secondary"
                className="mt-2 animate-up-2 ms-auto"
              >
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      {/* <UserOnboardingListTable key={refreshTable} handleEdit={handleEdit} />  */}
    </>
  );
};
